import React, { Component } from "react";
class Payment3DPending extends Component {
    render() {
        return (<div className="container">
            <h1>Pending</h1>
        </div>);
    }
}
export default Payment3DPending;